import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default payload => {
  let searchParams = '';
  if (payload && typeof payload === 'string') searchParams = `company: "${payload}"`;
  if (payload && typeof payload === 'object') {
    searchParams = convertFilterRequestUrl(payload, []);
    return gql`
    query {
      getUniqueProductLine(input: ${searchParams} ) {
        productLine
      }
    }
  `;
  }
  return gql`
  query {
    getUniqueProductLine(input: { ${searchParams} }) {
      productLine
    }
  }
`;
};
